import {Logger} from '#core/utils/logger.js';

import {DBXAbstractPerformanceLogger} from '#core/services/performance-reporting-service/abstract-performance-logger.js';
import {DBXPerformanceService, METRIC} from '#core/services/performance-reporting-service/index.js';
import {getCollectedTime} from '#core/services/performance-reporting-service/utils.js';
import {MessageId, postMessage} from '#core/application/api/messaging.ts';

const logger = Logger('Lifecycle');

const TIMEOUT = 20 * 1000; // 20 seconds

class AppLoadedNotifier extends DBXAbstractPerformanceLogger {
    reportTiming(name) {
        if (name === METRIC.INITIAL_PAGE_READY || name === METRIC.INITIAL_PAGE_INTERACTED_BEFORE_READY) {
            notifyAppIsLoaded();
        }
    }

    wsActivityMostlyFinished() {
        // Called when websocket activity is mostly finished
        // We treat it as lotto loaded
        DBXPerformanceService.reportDuration(METRIC.MOJ_TIMINGS_GET_CONFIG_DURATION, getCollectedTime('getConfig'));

        notifyAppIsLoaded();
    }
}

let appLoadedListener = null;
export function setAppLoadedListener(handler) {
    appLoadedListener = handler;
}

//===========================================
let triggered = false;
let timer = null;
let promiseResolve = null;
export function notifyAppIsLoaded() {
    if (triggered) return;
    try {
        triggered = true;
        logger.info(`${capitalize(PRODUCT_NAME)} loaded.`);
        performance.mark(`dbx:${PRODUCT_NAME}:loaded`);
        clearTimeout(timer);

        if (promiseResolve) promiseResolve();
        if (appLoadedListener) appLoadedListener();
        postMessage({id: MessageId.APPLICATION_LOADED});
    } catch (e) {
        logger.warn(`Failed to to notify about application loaded": ${e.message}`);
    }
}

export function createAppLoadedNotifier() {
    cancelAppLoadedNotifier();

    timer = setTimeout(notifyAppIsLoaded, TIMEOUT);

    return new Promise(resolve => {
        promiseResolve = resolve;
    });
}

export function cancelAppLoadedNotifier() {
    clearTimeout(timer);
    timer = null;
    triggered = false;
}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

DBXPerformanceService.addLogger(new AppLoadedNotifier());
